export const loginCoupon = {
    mounted() {
        let _newReg = this.$route.query.new_reg;
        if (_newReg && _newReg == 1) {
            this.$refs.cLoginCoupon.show = true;
        }
    }
}